import styled, { css } from 'styled-components'
import { mediaQueries } from '../../providers/MediaQueryProvider'

export const Container = styled.div<{ numberOfColumns: number; error?: boolean }>`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(${({ numberOfColumns }) => numberOfColumns}, 1fr);
  grid-auto-rows: auto;
  grid-gap: 1px;
  background: var(--border-secondary);
  border: 1px solid var(--border-secondary);

  ${({ error }) =>
    error &&
    css`
      border-color: var(--border-critical);
    `}
`

export const Option = styled.label<{ $active?: boolean; $empty?: boolean; $disabled?: boolean }>`
  display: flex;
  justify-content: center;
  position: relative;
  padding: var(--space-300) var(--space-200);
  outline-offset: -1px;
  cursor: pointer;
  background-color: var(--bg-primary);

  ${({ $active }) =>
    $active
      ? css`
          outline: 2px solid var(--border-primary);
        `
      : css`
          &:focus {
            outline: 1px solid var(--border-primary);
          }
        `}

  ${({ $empty }) =>
    $empty &&
    css`
      cursor: default;
      background-color: var(--bg-secondary);
    `}

  ${({ $disabled }) =>
    $disabled &&
    css`
      background: var(--bg-secondary);
      cursor: not-allowed;

      &:focus {
        outline: none;
      }
    `}

  ${mediaQueries.tablet} {
    padding: var(--space-400);
  }
`

export const ActiveTickContainer = styled.div`
  position: absolute;
  left: 3px;
  top: 3px;
  border-radius: 100%;
  padding: var(--space-100);
  background-color: var(--text-primary);
  color: var(--bg-primary);

  ${mediaQueries.tablet} {
    left: 5px;
    top: 5px;
  }
`

export const Input = styled.input`
  visibility: hidden;
  width: 0;
  height: 0;
  opacity: 0;
`
